export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14714.05b095e1.jpg";